var _path, _circle, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4043 4.16666L36.4355 4.18958C33.1001 4.18958 31.5313 3.13749 29.7126 1.91874C29.0897 1.50208 28.4626 1.08333 27.7668 0.704159C26.9105 0.237492 26.0209 0.0229085 25.0063 0.0020752C24.0938 0.0020752 23.0876 0.239575 22.2293 0.704159C21.5334 1.08333 20.9063 1.50208 20.2834 1.91874C18.4668 3.13749 16.8959 4.18958 13.5605 4.18958L10.5918 4.16666C6.86676 4.16666 4.1626 6.71666 4.1626 10.2312V25.8646C4.1626 37.2854 14.8834 45.2417 21.0793 48.85C22.0668 49.4396 23.0084 49.9958 24.9959 49.9979C26.9834 49.9958 27.9251 49.4375 28.9126 48.85C35.1084 45.2396 45.8293 37.2854 45.8293 25.8646V10.2312C45.8293 6.71666 43.1251 4.16666 39.4001 4.16666H39.4043ZM43.7501 25.8667C43.7501 36.2458 33.6563 43.6792 27.848 47.0646C26.9584 47.5958 26.4188 47.9167 25.0001 47.9187C23.5793 47.9187 23.0418 47.5958 22.1522 47.0646C16.3438 43.6792 6.2501 36.2458 6.2501 25.8667V18.75H43.7501V25.8667ZM43.7501 16.6667H6.2501V10.2312C6.2501 7.88749 8.03551 6.24999 10.5959 6.24999L13.5647 6.27291C17.5334 6.27291 19.523 4.93749 21.4459 3.64791C22.0168 3.26458 22.5897 2.87916 23.2272 2.53124C23.7751 2.23124 24.3751 2.11458 25.0063 2.08333C25.6147 2.01666 26.223 2.23333 26.7709 2.53124C27.4105 2.87916 27.9813 3.26666 28.5522 3.64791C30.4751 4.93749 32.4647 6.27291 36.4334 6.27291L39.4022 6.24999C41.9626 6.24999 43.748 7.88749 43.748 10.2312L43.7501 16.6667Z",
    fill: "#1D1D1D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 17.5,
    r: 8.25,
    fill: "white",
    stroke: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_3291",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 25.8334C26.0946 25.8348 27.1787 25.6199 28.1899 25.201C29.2012 24.7821 30.1196 24.1675 30.8926 23.3925C31.6676 22.6196 32.2822 21.7011 32.7011 20.6899C33.1199 19.6786 33.3348 18.5946 33.3334 17.5C33.3348 16.4055 33.1199 15.3214 32.701 14.3102C32.2821 13.299 31.6676 12.3805 30.8926 11.6075C30.1196 10.8325 29.2012 10.2179 28.1899 9.79906C27.1787 9.38018 26.0946 9.16528 25.0001 9.16669C23.9055 9.1653 22.8215 9.38022 21.8103 9.79909C20.799 10.218 19.8805 10.8326 19.1076 11.6075C18.3326 12.3805 17.718 13.299 17.2992 14.3102C16.8803 15.3214 16.6654 16.4055 16.6668 17.5C16.6653 18.5946 16.8802 19.6786 17.2991 20.6899C17.718 21.7011 18.3326 22.6196 19.1076 23.3925C19.8805 24.1675 20.799 24.7821 21.8103 25.201C22.8215 25.6198 23.9055 25.8348 25.0001 25.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 17.5L24.1667 20L29.1667 15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_3291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H35V27.5H15V7.5Z",
    fill: "#72B01D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityServicesIcon);
export default __webpack_public_path__ + "static/media/security_services_icon.1c3aef63550d51e16da8b1b00a766e2d.svg";
export { ForwardRef as ReactComponent };